module.exports = {"id":"222022","name":"Leonel Di Plácido","rating":"71","photo":"./data/images/photos/0/222022.png","club":{"name":"Lanús","logo":"./data/images/clubs/Lanus.png"},"positions":["DD","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeonelDiPlacido0.json
// module id = 2496
// module chunks = 0